import { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import axios from '../api/axios';
import useAuth from '../hooks/useAuth';
import Notification from './Notificaiton';

export default function NewUser(props) {


  const {auth} = useAuth();

  const [user,setUser] = useState({});

  const [notification, setNotification] = useState(false);
  const [notificationObject, setNotificationObject] = useState({})

  useEffect(() => {
      if(auth){
      setUser(auth);
      }
  }, [auth])

  const { onClose } = props;
    
  const [open, setOpen] = useState(props.state);

  const [formData, setFormData] = useState({
      firstname: "",
      username: "",
      role: "User"
  });

  const closePanel = e => {
    onClose();
    setNotification(false)
    setFormData({
      firstname: "",
      username: "",
      role: "User"
    })
  };

  const handleSubmit = async (e) => {
      e.preventDefault();

      const userObject = {
        firstname: formData.firstname,
        username: formData.username,
        role: formData.role,
        companyId: user?.companyId,
        sender: user?.firstname
      }

      try {
          const response = await axios.post(`/users`, userObject);
          setNotification(true);
          setNotificationObject({
            notification: 'success',
            title: 'Success!',
            message: response.data.message
          })
          closePanel();
      } catch (error) {
        console.log(error);
        setNotification(true);
        setNotificationObject({
          notification: 'warning',
          title: 'Error!',
          message: error.response.data.message
        })
        //setErrorTrue(true);
        //setError(error.response.data.message);
      }
  };

  useEffect(() => {
    setOpen(props.state);
  }, [props.state]);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closePanel}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <Notification notification={notification} notificationObject={notificationObject} />
          
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                    <div className="px-4 sm:px-6">
                      <div className="flex items-start justify-between">
                        <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                          Add user
                        </Dialog.Title>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={closePanel}
                          >
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="relative mt-0 flex-1 px-4 sm:px-6">

                      <form onSubmit={handleSubmit}>
                        <div className="space-y-12">
                          <div className="border-b border-gray-900/10 pb-12">
                            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="sm:col-span-4">
                                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                  First name
                                </label>
                                <div className="mt-2">
                                  <input
                                    id="firstname"
                                    name="firstname"
                                    type="text"
                                    autoComplete="email"
                                    value={formData.firstname}
                                    onChange={(e) => setFormData({...formData, firstname: e.target.value})}
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>      
                              <div className="sm:col-span-4">
                                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                  Email address
                                </label>
                                <div className="mt-2">
                                  <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    value={formData.username}
                                    onChange={(e) => setFormData({...formData, username: e.target.value})}
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>  
                              <div className="sm:col-span-4">
                              <label htmlFor="location" className="block text-sm font-medium leading-6 text-gray-900">
                                Role
                              </label>
                              <select
                                id="role"
                                name="role"
                                value={formData.role}
                                onChange={(e) => setFormData({...formData, role: e.target.value})}
                                className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                defaultValue="User"
                              >
                                <option>Admin</option>
                                <option>User</option>
                              </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="mt-6 flex items-center justify-end gap-x-6">
                          <button type="button" className="text-sm font-semibold leading-6 text-gray-900" onClick={closePanel}>
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          >
                            Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}